import { SET_SELECTED_COMPANY } from "@/store/mutations.js";
export const companies = {
  fields: {
    id: null,
    name: "",
  },
  getFormData: (state) => {
    let formData = new FormData();
    formData.append("id", state.selectedCompany.id);
    formData.append("name", state.selectedCompany.name);
    return formData;
  },
  saveCallBack: (response, state, dispatch) => {
    dispatch("fetchList");
  },
  validate: (state) => {
    return state.selectedCompany.name?.length > 2;
  },
  reset: (commit) => {
    commit(SET_SELECTED_COMPANY, {
      id: null,
      name: "",
      companies: [],
    });
  },
};
